var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CurrentPatientProvider, MeasurementList as MeasurementsUi, Spinner, } from "@madmedical/ui";
import { useParams } from "@madmedical/routing";
import { invariant } from "@madmedical/utils";
import { adaptPatient, usePatient } from "@madmedical/user";
import { useCallback, useState } from "react";
import { useGetMeasurementListQuery } from "../api";
import DeleteMeasurementDialog from "./DeleteMeasurementDialog";
const adapt = (_a) => {
    var { measuredAt, metric } = _a, rest = __rest(_a, ["measuredAt", "metric"]);
    return (Object.assign({ measuredAt: new Date(measuredAt), displayValue: metric.displayValue }, rest));
};
const MeasurementList = () => {
    var _a;
    const { metricType } = useParams();
    invariant(metricType);
    const { patientId: userId, isSelfOrRepresented, patient, isLoading: isPatientLoading, } = usePatient();
    const [page, setPage] = useState(1);
    const { currentData, isLoading } = useGetMeasurementListQuery({
        userId,
        metricType,
        page,
    });
    const [deleteMeasurementId, setDeleteMeasurementId] = useState();
    const handleDeletePress = useCallback((id) => {
        setDeleteMeasurementId(id);
    }, []);
    const handleDialogClose = useCallback(() => {
        setDeleteMeasurementId(undefined);
    }, []);
    const handleEndReached = useCallback(() => {
        if (!currentData) {
            return;
        }
        const { currentPage, pageCount } = currentData.pagination;
        if (currentPage >= pageCount) {
            return;
        }
        setPage(currentPage + 1);
    }, [currentData]);
    if (isLoading || isPatientLoading) {
        return _jsx(Spinner, {});
    }
    invariant(patient);
    return (_jsxs(CurrentPatientProvider, Object.assign({ value: { patient: adaptPatient(patient) } }, { children: [_jsx(MeasurementsUi, { metricType: metricType, data: (_a = currentData === null || currentData === void 0 ? void 0 : currentData.items.map(adapt)) !== null && _a !== void 0 ? _a : [], onEndReached: handleEndReached, isPatient: isSelfOrRepresented, onDeletePress: handleDeletePress }), _jsx(DeleteMeasurementDialog, { id: deleteMeasurementId, open: !!deleteMeasurementId, onClose: handleDialogClose })] })));
};
export default MeasurementList;
